import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  return <LmsTable 
    useApiFiltering
    apiSuffix="inspections/company-inspection-details"
    actionButtons={["add", "edit", "remove", "export"]} 
    deleteSuffix="inspections/company-inspection-details"
  />;
};

const inspectionCompanyInspectionDetailsFormFields = ( myForm, isEdit ) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Inspection Company Inspection", "inspections/list-nwcc-inspection", { name: "nwccinspectionId", required: true, disabled: isEdit }),
  ]);
  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan Budget Detail", "inspections/list-nwccinspection-loan-budget-details", { 
      name:"loanBudgetDetailId", 
      required: true, 
      dependencyField:"nwccinspectionId" 
    }),
    myForm.getInputField("Line Number", { required: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Percent Complete", { fieldType: "float" }),
    myForm.getInputField("Cumulative Percent Complete", { name: "cumulativePercentComplete", fieldType: "float" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Budget Group No"),
    myForm.getInputField("Budget Group"),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Description", { field: "textarea" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Comments", { name: "comment", field: "textarea" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Error Message", { field: "textarea" }),
  ]);

  return myForm;
};

const EditInspectionCompanyInspectionDetailsForm = ({ id }) => {
  const [{ data: companyInspectionDetail, isLoading, error }] = useFetchData(`inspections/company-inspection-detail/${id}`);
  const myForm = inspectionCompanyInspectionDetailsFormFields(
    new BCFormController(companyInspectionDetail, { 
      submitSuffix: "inspections/company-inspections/details", 
      submitMethod: "PUT", 
      clearSuffixesOnSubmit: [`inspections/company-inspection-detail/${id}`],
      dataFormatterFunc: (data) => { return {...data, nwccinspectionId: companyInspectionDetail?.nwccinspectionId }; },
      deleteSuffix: "inspections/company-inspection-details",
      blankWidth: 4 
    }),
    true
  );

  const formActions = ["save", "save-close", "delete", "close"];
  return (<LmsFormGenerator 
    myForm={myForm} 
    actions={formActions}
    isLoading={isLoading}
    error={error}
  />);
};

const AddInspectionCompanyInspectionDetailsForm = () => {
  const myForm = inspectionCompanyInspectionDetailsFormFields(
    new BCFormController({}, { submitSuffix: "inspections/company-inspection-detail", submitMethod: "POST", blankWidth: 4 }),
    false
  );

  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} />;
};

const LmsInspectionsInspectionCompanyInspectionDetails = ({
  params = {},
  history,
}) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } =
    useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isAdd && <AddInspectionCompanyInspectionDetailsForm />}
      {isEdit && <EditInspectionCompanyInspectionDetailsForm id={id} />}
    </>
  );
};

export default LmsInspectionsInspectionCompanyInspectionDetails;
